import { Component, Input, OnInit } from '@angular/core';
import { DriveHelperService } from '../../insurgo-services/drive-helper.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { ConfigurationService } from '../../insurgo-services/configuration.service';
import { InvestigoDrive } from '../../insurgo-classes/investigo-drive.class';
import { InvestigoScanner } from '../../insurgo-classes/investigo-scanner.class';
import { ExineAgGrid } from '../../insurgo-classes/exine-ag-grid';
import { ToastService } from '../../insurgo-services/toast.service';

@Component({
  selector: 'ngx-dispatch-hardware',
  templateUrl: './dispatch-hardware.component.html',
  styleUrls: ['./dispatch-hardware.component.scss']
})
export class DispatchHardware implements OnInit {

  @Input() public selectedDrives: InvestigoDrive[] = [];
  @Input() public selectedScanners: InvestigoScanner[] = [];

  public dispatchReference: string = '';
  public displayMessage: string = '';
  public showSuccess: boolean = false;
  public showError: boolean = false;
  public entryStatus: 'success' | 'danger' | 'warning' | undefined;

  public hardwareTable = new ExineAgGrid();

  constructor(private driveHelperService: DriveHelperService,
    private ref: NbDialogRef<DispatchHardware>,
    private configurationService: ConfigurationService,
    private toastService: ToastService
  ) {

    const columnDefs = [
      { headerName: 'Asset Tag', field: 'assetTag', minWidth: 120, flex: 1, sortable: true },
      { headerName: 'Hardware Type', field: 'hardwareTypeString', minWidth: 120, flex: 1, sortable: true },
    ];
    this.hardwareTable.columnDefs = columnDefs;

  }

  ngOnInit(): void {
    this.setRows(this.selectedDrives, this.selectedScanners);
  }

  public dispatchHardware() {

    this.showError = false;
    this.showSuccess = false;
    this.displayMessage = 'Dispatching in hardware...';

    if (this.selectedDrives.length === 0 && this.selectedScanners.length === 0) {
      this.displayMessage = 'No hardware to dispatch';
      this.onError();
      return;
    }

    if (this.dispatchReference.length === 0) {
      this.displayMessage = 'Please enter a dispatch reference';
      this.onError();
      return;
    }

    const nowInSeconds = Math.floor(Date.now() / 1000);

    const arrDriveIDs: number[] = this.selectedDrives.map(drive => drive.databaseID);
    const arrScannerIDs: number[] = this.selectedScanners.map(scanner => scanner.databaseID);

    this.driveHelperService.markHardwareAsDispatched(arrDriveIDs, arrScannerIDs, nowInSeconds, this.dispatchReference).subscribe({
      next: (result) => {
        // if no error, show success message
        let someSuccess = result.success.length > 0;
        let someError = result.errors.length > 0;

        if (someSuccess && !someError) {
          this.onSuccess();
        } else if (someSuccess && someError) {
          this.toastService.showToast('warning', 'Warning', `${result.success.length} item/s of hardware dispatched, ${result.errors.length} item/s could not be dispatched`);
          this.onPartialSuccess();
        } else {
          this.toastService.showToast('warning', 'Error', `${result.errors.length} item/s of hardware could not be dispatched`);
          this.onError();
        }
      },
      error: (error) => {
        console.log(error);
        this.displayMessage = error;
        this.toastService.showToast('error', 'Error', error);
        this.onError();
      }
    });
  }


  public onGridReady(params) {
    this.hardwareTable.gridApi = params.api;
  }

  public csvExport() {
    const fileName = `manifest_errors`;
    this.hardwareTable.gridApi.exportDataAsCsv({ fileName: fileName });
  }

  private setRows(dives: InvestigoDrive[], scanners: InvestigoScanner[]) {
    const newRows = [];
    for (const drive of dives) {
      newRows.push({
        assetTag: drive.assetTag,
        hardwareTypeString: drive.driveType
      });
    }
    for (const scanner of scanners) {
      let hardwareType = 'Scanner';
      if (scanner.isBarcodeEnabled) {
        hardwareType = 'Scanner (Barcode)';
      }
      newRows.push({
        assetTag: scanner.assetTag,
        hardwareTypeString: hardwareType
      });
    }

    this.hardwareTable.rowData = newRows;
  }
  private onSuccess() {
    this.configurationService.successSnd.play();
    this.showSuccess = true;
    this.entryStatus = 'success';
    setTimeout(() => {
      this.ref.close('success');
      this.entryStatus = undefined;
    }, 1000);
  }

  private onPartialSuccess() {
    this.configurationService.errorSnd.play();
    this.showSuccess = true;
    this.entryStatus = 'warning';
    setTimeout(() => {
      this.ref.close('partial-success');
      this.entryStatus = undefined;
    }, 1000);
  }

  private onError() {
    this.configurationService.errorSnd.play();
    this.showError = true;
    this.entryStatus = 'danger';
    setTimeout(() => {
      this.displayMessage = '';
      this.showError = false;
      this.entryStatus = undefined;
    }, 3000);
  }

}
